export const createFileId = (file: File): string =>
  `${file.name.replace(/[^a-zA-Z0-9]+/g, '_')}${file.lastModified}`;
